// ====================================================================================
// asVideo.module
// ====================================================================================
import $ from "jquery";
import Plyr from "plyr";
import { getEmbeddingAccepted, checkCMInit } from "./ccm19.module.js";

const players = {};
const plyrOptions = {
  iconUrl: asTemplateResourcePath + "Vendor/Plyr/plyr.svg",
  blankVideo: asTemplateResourcePath + "Vendor/Plyr/blank.mp4",
  youtube: { noCookie: true },
};

const videoDelay = false;
const videoInModal = false;

const initVideo = (id, inModal, delayed) => {
  let hashID = "#" + id;
  let $box = $(`[data-target="${id}"]`);
  let player = new Plyr(hashID, plyrOptions);

  player.on("ready", function (event) {
    let iPlayer = event.detail.plyr;
    players[iPlayer.media.id] = event.detail.plyr;

    iPlayer.on("playing", (event) => {
      $box.addClass("playing");
      $box.find(".video-play-button").removeClass("loading");
    });

    iPlayer.on("pause", (event) => $box.removeClass("playing"));
    iPlayer.on("ended", (event) => $box.removeClass("playing"));

    $box.removeClass("loading");

    if (inModal) {
      $box.find(".modal").on("show.bs.modal", function (e) {
        let mPlayer = players[id];
        mPlayer.play();
      });
      $box.find(".modal").on("hide.bs.modal", function (e) {
        let mPlayer = players[id];
        mPlayer.play();
      });
    }

    if (delayed) iPlayer.play();
  });
  if (delayed) $box.addClass("init");
};

const videoSetup = (className) => {
  if (className !== "local") {
    $("body").removeClass(`${className}No`);
    $(`.video-play-button.${className}`).css("display", "block");
  }
  $(`.js-player.${className}`).each(function () {
    let $box = $(this).parents(".video-box");
    $box.addClass("loading");
    if ($box.hasClass("init")) {
      let player;
      if ($box.find("video").length > 0) {
        player = players[$box.find("video").attr("id")];
      } else {
        player = players[$box.find("iframe").attr("id")];
      }
      player.play();
    } else {
      initVideo($box.attr("data-target"), videoInModal, videoDelay);
    }

    // Modal variant
    // let $target = $box.find(".video-play-button");
    // $target.on("click", function (e) {
    //   $target.addClass("loading");
    //   if ($box.hasClass("init")) {
    //     let player;
    //     if ($box.find("video").length > 0) {
    //       player = players[$box.find("video").attr("id")];
    //     } else {
    //       player = players[$box.find("iframe").attr("id")];
    //     }
    //     player.play();
    //   } else {
    //     initVideo($target.attr("data-target"), videoInModal, videoDelay);
    //   }
    // });
  });
};

const audioSetup = () => {
  $(".js-player.audio").each(function (e) {
    new Plyr(`#${$(this).attr("id")}`, plyrOptions);
  });
};

const checkExternlPlayerSetup = () => {
  if (checkCMInit()) {
    // Youtube
    if (getEmbeddingAccepted("YouTube Video")) {
      $("body").removeClass("noYoutube");
      document.querySelectorAll(".video-box.youtube").forEach((el) => {
        let dataVT = el.getAttribute("data-vt");
        let template = document.getElementById(dataVT);
        let templateContent = template.content;
        el.appendChild(templateContent);
      });
      $(".uc-notice.youtube").remove();
      videoSetup("youtube");
    } else $("body").addClass("noYoutube");

    // Vimeo
    if (getEmbeddingAccepted("Vimeo")) {
      $("body").removeClass("noVimeo");
      document.querySelectorAll(".video-box.vimeo").forEach((el) => {
        let dataVT = el.getAttribute("data-vt");
        let template = document.getElementById(dataVT);
        let templateContent = template.content;
        el.appendChild(templateContent);
      });
      $(".uc-notice.vimeo").remove();
      videoSetup("vimeo");
    } else $("body").addClass("noVimeo");
  } else {
    setTimeout(() => checkExternlPlayerSetup(), 500);
  }
};

export const init = () => {
  videoSetup("local");

  if (document.querySelector(".js-player.audio")) audioSetup();

  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      checkExternlPlayerSetup();
      $(".ce-gallery .video.hidden").removeClass("hidden");

      $(document).on("asuc-updated", () => checkExternlPlayerSetup());
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
